import {
  EligibleOffersProto,
  GetEligibleOffersResponseProto,
} from "@noom/noom-contracts/noom_contracts/offers/buyflow/api/eligible_offers_service";
import { appConfig } from "src/config";
import { getAuthHeader } from "src/utils/authCookieParser";
import getStore from "src/utils/redux/store";

export async function queryBuyflowEligibleOffers(): Promise<
  EligibleOffersProto[] | null
> {
  const authHeader = getAuthHeader();
  const accessCode = getStore().getState().userData.access_code;

  const response = await fetch(
    `${appConfig.OFFERS_API_URL}/offers/v1/user/${accessCode}/getEligibleOffers`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...authHeader,
      },
    }
  );

  if (!response.ok) {
    throw new Error(`Failed to get user details: ${response.status}`);
  }
  const result: GetEligibleOffersResponseProto = await response.json();
  return result.eligibleOffers;
}
